<template>
 <div v-loading="loading">
     <h3 style="marginTop: 0px">{{reportData.contractName}}</h3>
     <el-tag :key="tag.id" v-for="tag in reportData.programs" style="marginRight: 10px">
       {{tag.name}}
     </el-tag>
     <hr/>
     <h3>Activities</h3>
     <p>{{reportData.activities}}</p>
     <h3>Improvements</h3>
     <p>{{reportData.improvements}}</p>
     <h3>Feedback</h3>
     <p>{{reportData.feedback}}</p>
     <div v-if="isPendingManager">
       <el-button  @click="approveReport">Approve</el-button>
     </div>

 </div>
</template>
<script>
  import {auth, database} from '../main.js'
  import axios from 'axios'
  export default {
   props: ['reportData', 'updateReports'],
   data () {
     return {
       loading: false
     }
   },
   computed: {
     isPendingManager () {
       return this.reportData.status === 'pending' && auth.currentUser.uid === this.reportData.managerId
      }
   },
   methods: {
     async approveReport () {
       this.loading = true
       database.ref(`/reports/${this.reportData.reportId}`).update({status: 'complete'})
       let report = await database.ref(`/reports/${this.reportData.reportId}`).once('value')
       report = report.val()
       let user = await database.ref(`/users/${report.user}`).once('value')
       user = user.val()
       let manager = await database.ref(`/users/${report.managerId}`).once('value')
       manager = manager.val()
       await axios.post('https://us-central1-operations-60be9.cloudfunctions.net/reportApproved', {
         userName: user.firstName,
         userEmail: manager.email,
         managerName: `${manager.firstName} ${manager.lastName}`
       })
       this.loading = false
       this.testy()
     },
     testy () {
       this.$emit('updateReports')
     }
   }
 }
</script>



// WEBPACK FOOTER //
// src/components/ReportView.vue